import { AssignmentDTO } from 'models/assignment'
import { OrganizationProductKinds, ProductKind, ShootingCategory } from 'constants/product'

interface ProductWithKind {
  kind?: ProductKind | null
}

interface AssignmentWithProducts {
  products: AssignmentDTO['products']
}

/**
 * Resolves the meeting-type product to display in order/assignment detail views.
 *
 * Tries to find an organization-level product among `orderProducts` (KEYS_PICKUP, MEETING_ON_SITE,
 * ORGANIZATION_THIRD_PARTY). For real estate assignments without such an organization product,
 * falls back to a synthetic MEETING_ON_SITE since the backend does not always emit it.
 */
export function getMeetingTypeProduct(
  orderProducts: ProductWithKind[] | undefined,
  assignments: AssignmentWithProducts[] | undefined
): { kind: ProductKind } | undefined {
  const orgProduct = orderProducts?.find((p) => !!p.kind && OrganizationProductKinds.has(p.kind))
  if (orgProduct?.kind) return { kind: orgProduct.kind }

  const hasRealEstateAssignment = assignments?.some((a) =>
    a.products.some((product) => product.category === ShootingCategory.REAL_ESTATE)
  )
  if (hasRealEstateAssignment) return { kind: ProductKind.MEETING_ON_SITE }

  return undefined
}
